import { Injectable } from "@angular/core";
import { EntityInfoType, EntityInfoTypeHelper } from "@app/entity/model/entityinfo";
import { WebsocketService } from "@app/shared/databases/websocket";
import { ClareWSCrudHelperService } from "@app/shared/services/clare-ws-crud-helper.service";
import { DbCrudHelper } from "@app/shared/services/db-crud-helper";
import { TSLoggingService } from "@app/shared/services/ts-logging.service";
import { Observable, map } from "rxjs";

@Injectable()
export class EntityInfoTypeDbService {
    helper = EntityInfoTypeHelper;
    crudHelper = new DbCrudHelper(this.websocketService);
    wsHelper = new ClareWSCrudHelperService(this.tsLoggingService, this.crudHelper, this.helper);

    getAllEntityInfoTypes(): Observable<EntityInfoType[]> {
        return this.wsHelper.retrieve({ endpoint: "GetAllEntityinfoTypes" }).pipe(map(xs => xs.map(x => this.helper.fromDbObject(x))));
    }

    constructor(private tsLoggingService: TSLoggingService, private websocketService: WebsocketService) {}
}
